import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Heading } from '@chakra-ui/react';
import { useSemanticTypography } from '@whitbread-eos/utils';
import { jsx as _jsx } from "react/jsx-runtime";
export default function HotelTitle(_ref) {
  var name = _ref.name;
  var getTypographyProps = useSemanticTypography();
  var titleTypographyProps = getTypographyProps(titleLegacyTypography, titleSemanticTypography);
  var isSemanticTitleTypography = 'textStyle' in titleTypographyProps;
  return _jsx(Heading, _objectSpread(_objectSpread(_objectSpread({
    as: "h1",
    "data-testid": "hdp_hotelTitle"
  }, isSemanticTitleTypography ? {
    size: 'none'
  } : {}), titleTypographyProps), {}, {
    children: name
  }));
}
var titleLegacyTypography = {
  fontFamily: 'header',
  fontWeight: 'semibold',
  lineHeight: {
    base: 4,
    sm: 5
  },
  fontSize: {
    base: '2xl',
    sm: '3xxl'
  },
  letterSpacing: 'normal',
  textTransform: 'none'
};
var titleSemanticTypography = {
  textStyle: {
    base: 'heading-m',
    md: 'heading-xl'
  }
};